(function(){
'use strict';
var $=function(s,r){return (r||document).querySelector(s);};
var $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s));};
var RM=!!window.MD_STATIC||window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var SVGNS='http://www.w3.org/2000/svg';
function svgEl(t,a,p){var e=document.createElementNS(SVGNS,t);for(var k in a)e.setAttribute(k,a[k]);if(p)p.appendChild(e);return e;}
function onView(el,cb,opt){
if(!('IntersectionObserver' in window)){cb(true);return;}
var io=new IntersectionObserver(function(es){es.forEach(function(e){cb(e.isIntersecting,io);});},opt||{threshold:.15});
io.observe(el);return io;
}
function emit(n,d){document.dispatchEvent(new CustomEvent(n,{detail:d}));}
function appbar(){
var b=$('.md-bar');if(!b)return;
var f=function(){b.classList.toggle('is-scrolled',scrollY>12);};
addEventListener('scroll',f,{passive:true});f();
}
function reveal(){
$$('[data-md-reveal]').forEach(function(el){
if(RM){el.classList.add('is-in');return;}
onView(el,function(v,io){if(v){el.classList.add('is-in');io.unobserve(el);}},{threshold:.08,rootMargin:'0px 0px -40px 0px'});
});
}
function gallery(root){
var track=$('.md-track',root),thumbs=$('.md-thumbs',root),fig=$('[data-md-fig]',root);
var n=$$('.md-slide',root).length;
function idx(){return Math.round(track.scrollLeft/Math.max(1,track.clientWidth));}
function go(i){i=(i+n)%n;track.scrollTo({left:i*track.clientWidth,behavior:RM?'auto':'smooth'});}
var raf;
track.addEventListener('scroll',function(){
cancelAnimationFrame(raf);
raf=requestAnimationFrame(function(){
var i=idx();
if(fig)fig.textContent=String(i+1).padStart(2,'0')+' / '+String(n).padStart(2,'0');
if(!thumbs)return;
$$('.md-th',thumbs).forEach(function(t){t.classList.toggle('on',+t.dataset.i===i);});
var t=$('.md-th[data-i="'+i+'"]',thumbs);
if(t){var l=t.offsetLeft,r=l+t.offsetWidth;
if(l<thumbs.scrollLeft)thumbs.scrollLeft=l-6;
else if(r>thumbs.scrollLeft+thumbs.clientWidth)thumbs.scrollLeft=r-thumbs.clientWidth+6;}
});
},{passive:true});
if(thumbs)thumbs.addEventListener('click',function(e){var t=e.target.closest('.md-th');if(t)go(+t.dataset.i);});
var vids=$$('video',root),seen=false,cur=-1;
function playAt(i){vids.forEach(function(v){var on=seen&&!RM&&v.closest('.md-slide')===$$('.md-slide',root)[i];if(on){if(v.preload==='none')v.preload='auto';var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});}else if(!v.paused)v.pause();});}
if(vids.length){
if(RM)vids.forEach(function(v){v.controls=true;});
track.addEventListener('scroll',function(){var i=idx();if(i!==cur){cur=i;playAt(i);}},{passive:true});
onView(root,function(v){seen=v;playAt(idx());},{threshold:.35});
}
$$('[data-md-step]',root).forEach(function(b){b.addEventListener('click',function(){go(idx()+(+b.dataset.mdStep));});});
root.addEventListener('keydown',function(e){if(e.key==='ArrowRight')go(idx()+1);if(e.key==='ArrowLeft')go(idx()-1);});
}
function lugGlyph(n){
var s='<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" aria-hidden="true">';
s+='<path d="M28.6 39.5 L29.4 60 Q32 62.4 34.6 60 L35.4 39.5" fill="#fff"/><path d="M30 46h4" opacity=".5"/>';
s+='<circle cx="32" cy="24" r="16" fill="#fff"'+(n?'':' stroke-width="2.6"')+'/><circle cx="32" cy="24" r="11" stroke-dasharray="2.2 2.2" opacity=".6"/>';
var angs=n===2?[0,180]:n===3?[90,210,330]:[];
angs.forEach(function(a){
var r=a*Math.PI/180,x=32+Math.cos(r)*18.5,y=24-Math.sin(r)*18.5;
s+='<rect x="'+(x-4).toFixed(1)+'" y="'+(y-2.6).toFixed(1)+'" width="8" height="5.2" rx="1.4" transform="rotate('+(-a+90)+' '+x.toFixed(1)+' '+y.toFixed(1)+')" fill="currentColor" stroke="none"/>';
});
return s+'</svg>';
}
var LUGN={'2 ears':2,'3 ears':3,'2 lugs':2,'3 lugs':3,'None':0};
var FITS={'51 mm':'<b>Fits De’Longhi:</b> Dedica, La Specialista, Stilosa.','53 mm':'<b>Fits La Spaziale:</b> Vivaldi II, Mini Vivaldi II, Dream.','54 mm':'<b>Fits Breville and Sage:</b> Barista Express, Pro, Touch, Bambino, Infuser.','58 mm':'<b>Fits standard 58 mm:</b> E61 machines, Gaggia Classic, Rancilio Silvia, La Marzocco.'};
var LUGT={2:'Slots for 2 ears on the portafilter.',3:'Slots for 3 ears on the portafilter.',0:'No ear slots, it sits on the basket rim.'};
function buy(root){
var data;try{data=JSON.parse($('script[data-md-variants]',root).textContent);}catch(e){console.error('[mechadi] variants',e);return;}
var groups=$$('[data-md-opt]',root);
groups.forEach(function(g){
var bs=$$('.md-opt',g);
if(bs.every(function(b){return /^\d/.test(b.dataset.value);})){
bs.sort(function(a,b){return parseFloat(a.dataset.value)-parseFloat(b.dataset.value);}).forEach(function(b){g.insertBefore(b,$('.md-unit',g));});
}
});
var idIn=$('input[name="id"]',root),now=$('[data-md-now]',root),was=$('[data-md-was]',root),
sku=$('[data-md-sku]',root),cta=$('.md-cta',root),addB=$('[data-md-add]',root),ctaP=$('[data-md-cta-price]',root),help=$('[data-md-help]',root),save=$('[data-md-save]',root);
function sel(){return groups.map(function(g){var b=$('.md-opt[aria-checked="true"]',g);return b?b.dataset.value:null;});}
function set(g,val){
$$('.md-opt',g).forEach(function(b){var on=b.dataset.value===val;b.setAttribute('aria-checked',on);b.tabIndex=on?0:-1;});
}
function sync(push){
var s=sel();
var v=data.find(function(x){return x.o.every(function(o,i){return o===s[i];});});
if(!v)return;
idIn.value=v.id;
now.textContent=v.p;
if(was){was.textContent=v.c||'';was.hidden=!v.c;}
if(ctaP)ctaP.textContent=v.p;
if(save)save.textContent=v.d?'You save '+v.d:'';
if(sku)sku.textContent=v.s||'';
cta.disabled=!v.a;if(addB)addB.disabled=!v.a;
$('[data-md-cta-label]',root).textContent=v.a?'Buy now':'Sold out';
if(help){
var bi=groups.findIndex(function(g){return g.dataset.mdOpt==='Basket';});
var li=groups.findIndex(function(g){return g.dataset.mdOpt==='Ears'||g.dataset.mdOpt==='Lug slots';});
var n=li>-1?LUGN[s[li]]:2; if(n===undefined)n=2;
var t=(bi>-1&&FITS[s[bi]]?FITS[s[bi]]+' ':'')+LUGT[n];
$('[data-md-help-ico]',help).innerHTML=lugGlyph(n);
$('[data-md-help-txt]',help).innerHTML=t+' <a href="#fit">Fit guide</a>';
}
if(push&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);}
var opts={};groups.forEach(function(g,i){opts[g.dataset.mdOpt]=s[i];});
emit('md:variant',{sku:v.s,id:v.id,options:opts,price:v.p});
}
groups.forEach(function(g){
g.addEventListener('click',function(e){var b=e.target.closest('.md-opt');if(!b)return;set(g,b.dataset.value);sync(true);});
g.addEventListener('keydown',function(e){
var k=e.key;if(['ArrowRight','ArrowDown','ArrowLeft','ArrowUp'].indexOf(k)<0)return;
e.preventDefault();var bs=$$('.md-opt',g),i=bs.findIndex(function(b){return b.getAttribute('aria-checked')==='true';});
i=(i+(k==='ArrowRight'||k==='ArrowDown'?1:-1)+bs.length)%bs.length;set(g,bs[i].dataset.value);bs[i].focus();sync(true);
});
});
document.addEventListener('md:pick',function(e){
var d=e.detail||{};
groups.forEach(function(g){if(d[g.dataset.mdOpt])set(g,d[g.dataset.mdOpt]);});
sync(true);
var card=$('.md-buy',root)||root;
card.scrollIntoView({behavior:RM?'auto':'smooth',block:'center'});
card.animate&&!RM&&card.animate([{boxShadow:'0 0 0 0 rgba(31,34,35,.0)'},{boxShadow:'0 0 0 6px rgba(31,34,35,.14)'},{boxShadow:'0 0 0 0 rgba(31,34,35,.0)'}],{duration:900,delay:350});
});
var form=$('form',root);
if(form&&window.fetch)form.addEventListener('submit',function(e){
if(typeof window.openRzpCheckout==='function'){e.preventDefault();cta.disabled=true;
fetch('/cart/clear.js',{method:'POST',headers:{Accept:'application/json'}}).then(function(){return fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});}).then(function(r){if(!r.ok)throw r;return r.json();}).then(function(){if(window.mdCart)window.mdCart.refresh();window.openRzpCheckout();}).catch(function(){form.submit();}).then(function(){sync(false);});
return;}
if(!window.mdCart)return;e.preventDefault();cta.disabled=true;
fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)}).then(function(r){if(!r.ok)throw r;return r.json();}).then(function(){window.mdCart.open();}).catch(function(){form.submit();}).then(function(){sync(false);});
});
if(addB&&form&&window.fetch)addB.addEventListener('click',function(){
var lb=$('[data-md-add-label]',addB);addB.disabled=true;lb.textContent='Adding';
fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)}).then(function(r){if(!r.ok)throw r;return r.json();}).then(function(){if(window.mdCart)window.mdCart.open();else location.href='/cart';}).catch(function(){lb.textContent='Try again';setTimeout(function(){lb.textContent='Add to cart';},1800);}).then(function(){if(lb.textContent==='Adding')lb.textContent='Add to cart';sync(false);});
});
var cur=data.find(function(x){return String(x.id)===String(root.dataset.current);})||data[0];
if(cur)groups.forEach(function(g,i){set(g,cur.o[i]);});
sync(false);
}
function readouts(){
document.addEventListener('md:variant',function(e){
var d=e.detail;
$$('[data-md-live="sku"]').forEach(function(x){x.textContent=d.sku;});
$$('[data-md-live-opt]').forEach(function(x){x.classList.toggle('is-on',d.options[x.dataset.mdLiveOpt]===x.dataset.v);});
$$('.fit-c').forEach(function(c){c.classList.toggle('is-sel',c.dataset.v===d.options.Basket);});
});
document.addEventListener('click',function(e){
var b=e.target.closest('[data-md-pick]');if(!b)return;
e.preventDefault();var o={};o[b.dataset.mdPickOpt||'Basket']=b.dataset.mdPick;emit('md:pick',o);
});
}
function strip(root){
var t=$('.md-strip-t',root);if(!t)return;
t.innerHTML+=t.innerHTML;
}
function blueprint(root){
var svg=$('.bp-svg',root),stage=$('.bp-stage',root),lead=$('.bp-lead',root);
if(!svg)return;
var pins=$$('.bp-pin',root),items=$$('.bp-li',root);
var W=+root.dataset.w,H=+root.dataset.h;
pins.forEach(function(p){
var ax=+p.dataset.ax,ay=+p.dataset.ay,ly=+p.dataset.ly,lx=+p.dataset.lx;
p.style.left=(lx/W*100)+'%';p.style.top=(ly/H*100)+'%';
var ex=lx-24;
var g=svgEl('g',{},lead);
svgEl('line',{x1:ax,y1:ay,x2:ex,y2:ly},g);svgEl('line',{x1:ex,y1:ly,x2:lx,y2:ly},g);
svgEl('circle',{cx:ax,cy:ay,r:6},g);
});
lead.setAttribute('viewBox','0 0 '+W+' '+H);
function focus(keys){
root.classList.toggle('has-focus',!!keys);
$$('path',svg).forEach(function(p){p.classList.toggle('is-on',!!keys&&keys.indexOf(p.dataset.part)>-1);});
var k=keys?keys.join(','):'';
pins.forEach(function(p){p.classList.toggle('is-on',!!keys&&p.dataset.parts.split(',').some(function(x){return keys.indexOf(x)>-1;}));});
items.forEach(function(p){p.classList.toggle('is-on',!!keys&&p.dataset.parts===k);});
}
pins.concat(items).forEach(function(el){
var keys=el.dataset.parts.split(',');
el.addEventListener('mouseenter',function(){focus(keys);});
el.addEventListener('mouseleave',function(){focus(null);});
el.addEventListener('focus',function(){focus(keys);});
el.addEventListener('blur',function(){focus(null);});
});
if(RM)return;
svg.classList.add('drawable');
onView(stage,function(v,io){if(v){io.disconnect();requestAnimationFrame(function(){svg.classList.add('is-drawn');});}},{threshold:.2});
}
var MECH={
scale:20.53,cx:899,cy:900,ring:59,
gears:{
gear_core:{c:[13.36,2.81],T:33},
gear_rim:{c:[-4.76,-22.61],T:15},
gear_mid:{c:[-20.81,-5.5],T:18},
gear_idler:{c:[-10.42,7.02],T:13,idler:true}
},
needles:[[-13.67,-3.99,'gear_mid'],[-8.27,-18.7,'gear_rim'],[-6.9,7.77,'gear_idler'],[-6.55,-28.07,'gear_rim'],
[-1.73,-21.96,'gear_rim'],[5.14,11.97,'gear_core'],[8.66,-11.54,'gear_core'],[21.77,4.59,'gear_core']]
};
function gearAngle(g,th){return g.idler?th*(1+MECH.ring/g.T):th*(1-MECH.ring/g.T);}
function needleAt(n,th){
var g=MECH.gears[n[2]],c=g.c,ph=gearAngle(g,th);
var gx=c[0]*Math.cos(th)-c[1]*Math.sin(th),gy=c[0]*Math.sin(th)+c[1]*Math.cos(th);
var dx=n[0]-c[0],dy=n[1]-c[1];
return [gx+dx*Math.cos(ph)-dy*Math.sin(ph),gy+dx*Math.sin(ph)+dy*Math.cos(ph)];
}
function mechanism(root){
var svg=$('.mx-p svg',root),cv=$('.mx-p canvas',root);
if(!svg||!cv)return;
var S=MECH.scale,CX=MECH.cx,CY=MECH.cy,groups={};
Object.keys(MECH.gears).forEach(function(k){
var g=svgEl('g',{});var p=$('path[data-part="'+k+'"]',svg);if(!p)return;
p.parentNode.insertBefore(g,p);g.appendChild(p);groups[k]=g;
});
MECH.needles.forEach(function(n){
var g=groups[n[2]];if(!g)return;
svgEl('circle',{cx:CX+n[0]*S,cy:CY-n[1]*S,r:13,fill:'#fff','stroke-width':2.2},g);
svgEl('circle',{cx:CX+n[0]*S,cy:CY-n[1]*S,r:4.5,fill:'currentColor',stroke:'none'},g);
});
var carrier=$('path[data-part="carrier"]',svg);
if(carrier){var cg=svgEl('g',{});carrier.parentNode.insertBefore(cg,carrier);cg.appendChild(carrier);groups.carrier=cg;}
var ctx=cv.getContext('2d'),dpr=Math.min(devicePixelRatio||1,2),R=31,size=0;
var TURNS=8,STEPS=720,GEAR_PER=+root.dataset.gearSecs||4.2,TRACE_SECS=+root.dataset.traceSecs||8;
var paths=MECH.needles.map(function(n){var a=[];for(var i=0;i<=TURNS*STEPS;i++)a.push(needleAt(n,i/STEPS*2*Math.PI));return a;});
var ticks=$$('.mx-ticks i b',root),turnEl=$('[data-mx-turn]',root),scrub=$('.mx-scrub input',root),knob=$('.mx-knob',root);
var gTh=0,nT=0,last=0,running=false,hold=0,manual=false,idle=0;
function fit(){size=cv.clientWidth;cv.width=size*dpr;cv.height=size*dpr;}
function P(p){var k=size/2/R;return [size/2+p[0]*k,size/2-p[1]*k];}
function gears(th){
var deg=-th*180/Math.PI;
Object.keys(MECH.gears).forEach(function(k){
var g=MECH.gears[k],c=g.c,sx=CX+c[0]*S,sy=CY-c[1]*S,rel=-(gearAngle(g,th)-th)*180/Math.PI;
if(groups[k])groups[k].setAttribute('transform','rotate('+(deg%360).toFixed(3)+' '+CX+' '+CY+') rotate('+(rel%360).toFixed(3)+' '+sx.toFixed(1)+' '+sy.toFixed(1)+')');
});
if(groups.carrier)groups.carrier.setAttribute('transform','rotate('+(deg%360).toFixed(3)+' '+CX+' '+CY+')');
}
function trace(turns){
var th=turns*2*Math.PI,upto=Math.min(TURNS*STEPS,Math.floor(turns*STEPS));
ctx.setTransform(dpr,0,0,dpr,0,0);ctx.clearRect(0,0,size,size);
ctx.save();ctx.setLineDash([4,4]);ctx.strokeStyle='#B1B2B2';ctx.lineWidth=1;
ctx.beginPath();var c0=P([0,0]);ctx.arc(c0[0],c0[1],29.5*size/2/R,0,7);ctx.stroke();ctx.restore();
ctx.strokeStyle='rgba(31,34,35,.34)';ctx.lineWidth=.8;ctx.lineJoin='round';
paths.forEach(function(a){
ctx.beginPath();var q=P(a[0]);ctx.moveTo(q[0],q[1]);
for(var i=1;i<=upto;i++){q=P(a[i]);ctx.lineTo(q[0],q[1]);}
ctx.stroke();
});
ctx.fillStyle='#1F2223';
MECH.needles.forEach(function(n){var q=P(needleAt(n,th));ctx.beginPath();ctx.arc(q[0],q[1],2.6,0,7);ctx.fill();});
ticks.forEach(function(t,i){t.style.transform='scaleX('+Math.max(0,Math.min(1,turns-i))+')';});
if(turnEl)turnEl.textContent=Math.min(TURNS,turns).toFixed(1);
if(knob)knob.style.left=(turns/TURNS*100)+'%';
if(scrub&&!manual)scrub.value=turns;
}
fit();addEventListener('resize',function(){fit();trace(nT);});
if(scrub){
scrub.addEventListener('input',function(){manual=true;idle=2.5;nT=+scrub.value;trace(nT);});
scrub.addEventListener('change',function(){idle=2.5;});
}
if(RM){nT=TURNS;gears(0);trace(nT);return;}
function loop(t){
if(!running)return;
var dt=last?Math.min(.05,(t-last)/1000):0;last=t;
gTh+=dt*2*Math.PI/GEAR_PER;gears(gTh);
if(manual){idle-=dt;if(idle<=0){manual=false;if(nT>=TURNS)hold=1.2;}}
else if(hold>0){hold-=dt;if(hold<=0)nT=0;trace(nT);}
else{nT+=dt*TURNS/TRACE_SECS;if(nT>=TURNS){nT=TURNS;hold=2.4;}trace(nT);}
requestAnimationFrame(loop);
}
gears(0);trace(0);
onView(root,function(v){var was=running;running=v;last=0;if(v&&!was)requestAnimationFrame(loop);},{threshold:.1});
}
var ACC={mechanism:'Consistent, channel-free pucks',build:'See it inside out',depth:'Match the needles to your basket',fit:'Which size fits your machine',specs:'What’s in the box, specs, shipping, returns'};
function accordions(){
if(!window.matchMedia)return;
var mq=matchMedia('(max-width:700px)'),secs=[];
var css='.md-acc-t,.md-acc-i{display:none}@media(max-width:700px){.md-acc{padding-top:0!important}.md-acc .md-sh{grid-template-columns:auto 1fr auto;cursor:pointer;padding:22px 0 16px;-webkit-tap-highlight-color:transparent;user-select:none}.md-acc .md-sh .md-h2{font-size:21px}.md-acc-t{display:block;grid-column:2;font-size:13px;line-height:1.4;color:var(--soft);margin-top:-10px}.md-acc-i{display:block;grid-column:3;grid-row:1/span 2;align-self:center;width:30px;height:30px;border-radius:50%;border:1px solid var(--rule);position:relative;transition:background .2s,border-color .2s}.md-acc-i::before,.md-acc-i::after{content:"";position:absolute;left:50%;top:50%;width:11px;height:1.5px;margin:-.75px 0 0 -5.5px;background:var(--ink);transition:transform .25s var(--ease),background .2s}.md-acc-i::after{transform:rotate(90deg)}.md-acc.is-open .md-acc-i{background:var(--ink);border-color:var(--ink)}.md-acc.is-open .md-acc-i::before,.md-acc.is-open .md-acc-i::after{background:var(--paper)}.md-acc.is-open .md-acc-i::after{transform:rotate(0)}.md-acc .md-sh+.dash{margin-bottom:0}.md-acc:not(.is-open) .md-acc-b{display:none}.md-acc.is-open .md-acc-b{padding-top:22px;padding-bottom:12px;animation:md-acc-in .35s var(--ease)}}@keyframes md-acc-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}';
var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);
$$('.md-sec').forEach(function(sec){
var head=$('.md-sh',sec);if(!head)return;
var box=head.parentNode,after=head.nextElementSibling&&head.nextElementSibling.classList.contains('dash')?head.nextElementSibling:head;
var body=document.createElement('div');body.className='md-acc-b';
while(after.nextSibling)body.appendChild(after.nextSibling);
box.appendChild(body);sec.classList.add('md-acc');
if(ACC[sec.id]){var p=document.createElement('p');p.className='md-acc-t';p.textContent=ACC[sec.id];head.appendChild(p);}
var ic=document.createElement('span');ic.className='md-acc-i';head.appendChild(ic);
sec._acc=function(o){sec.classList.toggle('is-open',o);if(mq.matches)head.setAttribute('aria-expanded',o);if(o)setTimeout(function(){dispatchEvent(new Event('resize'));},40);};
head.addEventListener('click',function(){if(mq.matches)sec._acc(!sec.classList.contains('is-open'));});
head.addEventListener('keydown',function(e){if(mq.matches&&(e.key==='Enter'||e.key===' ')){e.preventDefault();sec._acc(!sec.classList.contains('is-open'));}});
secs.push({sec:sec,head:head});
});
function apply(){secs.forEach(function(o){if(mq.matches){o.head.setAttribute('role','button');o.head.tabIndex=0;o.head.setAttribute('aria-expanded',o.sec.classList.contains('is-open'));}else{o.head.removeAttribute('role');o.head.removeAttribute('tabindex');o.head.removeAttribute('aria-expanded');}});}
if(secs[0])secs[0].sec._acc(true);
apply();if(mq.addEventListener)mq.addEventListener('change',apply);
function openFor(id){var el=id&&document.getElementById(id),sec=el&&(el.closest('.md-acc'));if(sec&&mq.matches&&!sec.classList.contains('is-open'))sec._acc(true);}
document.addEventListener('click',function(e){var a=e.target.closest('a[href*="#"]');if(!a)return;var h=a.getAttribute('href').split('#')[1];openFor(h);},true);
if(location.hash)openFor(location.hash.slice(1));
}
function cartDrawer(){
var root=$('#mdCart');if(!root)return;
var items=$('[data-md-cd-items]',root),empty=$('[data-md-cd-empty]',root),foot=$('[data-md-cd-foot]',root),cnt=$('[data-md-cd-count]',root),sub=$('[data-md-cd-sub]',root),sub2=$('[data-md-cd-sub2]',root),lastFocus=null;
function money(c){var v=c/100;return 'Rs. '+v.toLocaleString('en-IN',{minimumFractionDigits:v%1?2:0,maximumFractionDigits:2});}
function esc(x){return String(x==null?'':x).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function img(u){return u?u+(u.indexOf('?')>-1?'&':'?')+'width=200':'';}
function badge(n){$$('.md-cart').forEach(function(a){var b=$('b',a);if(n>0){if(!b){b=document.createElement('b');a.appendChild(b);}b.textContent=n;}else if(b)b.remove();a.setAttribute('aria-label','Cart'+(n?', '+n+' item'+(n>1?'s':''):''));});}
function render(c){
if(!c||!c.items)return;
badge(c.item_count);cnt.textContent=c.item_count?String(c.item_count):'';
var has=c.items.length>0;empty.hidden=has;foot.hidden=!has;items.hidden=!has;
sub.textContent=money(c.total_price);sub2.textContent=money(c.total_price);
items.innerHTML=c.items.map(function(it,i){
var v=(it.options_with_values||[]).map(function(o){return esc(o.value);}).join(' · ');
var was=it.original_line_price>it.final_line_price?'<s>'+money(it.original_line_price)+'</s>':'';
return '<div class="md-cd-i" data-line="'+(i+1)+'">'+(it.image?'<img class="md-cd-img" src="'+esc(img(it.image))+'" alt="" width="76" height="76">':'<span class="md-cd-img"></span>')+
'<div><p class="md-cd-n">'+esc(it.product_title)+'</p>'+(v?'<p class="md-cd-v">'+v+'</p>':'')+
'<div class="md-cd-r"><div class="md-cd-q"><button type="button" data-q="-1" aria-label="Decrease quantity"'+(it.quantity<=1?' disabled':'')+'>−</button><span>'+it.quantity+'</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></div><p class="md-cd-pr">'+was+money(it.final_line_price)+'</p></div>'+
'<button type="button" class="md-cd-rm" data-q="0">Remove</button></div></div>';
}).join('');
}
function load(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){render(c);return c;}).catch(function(){});}
function change(line,q){root.classList.add('is-busy');return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:line,quantity:q})}).then(function(r){return r.json();}).then(render).catch(load).then(function(){root.classList.remove('is-busy');});}
function open(){lastFocus=document.activeElement;root.classList.add('is-open');root.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';load();setTimeout(function(){var x=$('.md-cd-x',root);if(x)x.focus();},60);}
function close(){if(!root.classList.contains('is-open'))return;root.classList.remove('is-open');root.setAttribute('aria-hidden','true');document.documentElement.style.overflow='';if(lastFocus&&lastFocus.focus)lastFocus.focus();}
addEventListener('click',function(e){if(!(e.target.closest&&e.target.closest('.md-cd-form button')))return;if(typeof window.openRzpCheckout==='function'){e.preventDefault();e.stopPropagation();close();window.openRzpCheckout();return;}setTimeout(close,0);},true);
document.addEventListener('click',function(e){
var a=e.target.closest('.md-cart');if(a){e.preventDefault();open();return;}
if(!root.contains(e.target))return;
var c=e.target.closest('[data-md-cd-close]');if(c){if(c.tagName!=='A')e.preventDefault();close();return;}
var q=e.target.closest('[data-q]');if(q){var row=q.closest('[data-line]'),n=+row.dataset.line,cur=+$('.md-cd-q span',row).textContent,d=+q.dataset.q;change(n,d===0?0:Math.max(0,cur+d));}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
document.addEventListener('md:cart-open',open);
addEventListener('pageshow',function(e){if(e.persisted)load();});
window.mdCart={open:open,close:close,refresh:load};
}
function init(){
accordions();appbar();reveal();readouts();cartDrawer();
$$('[data-md-gal]').forEach(gallery);
$$('[data-md-strip]').forEach(strip);
$$('[data-md-bp]').forEach(blueprint);
$$('[data-md-mech]').forEach(mechanism);
$$('[data-md-glyph]').forEach(function(el){el.innerHTML=lugGlyph(+el.dataset.mdGlyph);});
$$('[data-md-buy]').forEach(buy);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
